import {Component, OnInit, QueryList, ViewChildren} from '@angular/core';
import { ApprovalService } from '../../../services/approval.service';
import {ConsultantService} from "../../../services/consultant.service";
import {Router} from "@angular/router";
import {ApprovalBoxComponent} from "../approval-box/approval-box.component";
import {ToastsManager} from "ng2-toastr";
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { ElegibleForDiscount } from '../../../models/ElegibleForDiscount.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-multi-approvals',
  templateUrl: './edit-multi-approvals.component.html',
  styleUrls: ['./edit-multi-approvals.component.scss']
})
export class EditMultiApprovalsComponent implements OnInit {
    @ViewChildren(ApprovalBoxComponent) approvalsChildren: QueryList<ApprovalBoxComponent>

    multiApprovals:any = [];
    approvals:any = [];
    approvalsNumber:number = 0;
    errors:any = [];
    descontar:boolean = false;
    extras:boolean = false;
    approvalType:number=1;
    status:number = 2;
    days;
    objProject: any;
    arrObjProject = new Array();
    horasAMaisMesDescontar:number = 0;
    elegibleCapacityFlag:boolean = false;
    elegibleContractFlag:boolean = false;
    elegibleExtrasFlag:boolean = false;
    openHoursFlag:boolean = false;


  constructor(private ApprovalService: ApprovalService,
              private router:Router,
              public toastr: ToastsManager,
              private consultantService: ConsultantService,
              private projectFinancialService: ProjectFinancialService) { }

  async ngOnInit() {
    this.objProject = await this.projectFinancialService.getAllProjectsFinancial();
    this.multiApprovals = this.ApprovalService.multiApprovals;
    this.approvalsNumber = this.ApprovalService.multiApprovals.length;
    this.ApprovalService.multiApprovals.forEach(element => {
        this.arrObjProject.push(Object.create(this.objProject));
    });
    this.days = localStorage.getItem('days');
  }

  ngOnDestroy(){
    this.ApprovalService.multiApprovals = [];
  }


    OnCancel(){
        this.router.navigate(['/approvals']);
        this.ApprovalService.multiApprovals = [];
    }

    async onSave(){
        let approvalArray = this.approvalsChildren.toArray();
        for(let item of approvalArray){
            await this.saveApproval(item);
        }
        if(this.errors == 0){
            this.toastr.success('Aprovações editadas com sucesso!');
            this.router.navigate(['/approvals']);
        }else{
            this.toastr.warning('As aprovações dos seguintes consultores não puderam ser editadas:');
            for(let consultant of this.errors){
                this.toastr.warning(`${consultant}`);
            }
            this.router.navigate(['/approvals']);
        }
    }

    async saveApproval(item){
        if(await this.validProjectsSelected(item)) {
            this.toastr.warning('Selecione um projeto para cada apontamento');
            this.errors.push(item.approval.consultant.name);
            return;
        }

        if(this.checkForExternalReferences(item)){
            this.toastr.warning('Cliente não vinculado ao Hashtrack');
            return;
        }

        item.approval.status = this.status;
        if(this.status == 2){
            item.sumProjectHours(item.approval);
            item.approval.totalValue = item.approval.consultant.contract.totalValue;
            item.approval.totalValue = this.checkMatchHours(item.approval)? item.approval.consultant.contract.hourValue*(item.totalProjectHours-item.horasAMaisMesDescontar):item.approval.consultant.contract.totalValue;
            item.approval.realizedHours = item.totalProjectHours;
            item.approval.approvalType = item.approvalType;
            
        }
        if(this.descontar && item.approval.status == 2) {
            item.approval.totalValue = item.descontar?item.getDiscountedValue():(item.totalValue<item.approval.consultant.contract.totalValue?item.approval.consultant.contract.totalValue:item.totalValue);
            item.approval.discounted = true;
            item.approval.discountValue = this.getDiscount(item) != undefined ? this.getDiscount(item) : 0;
            item.approval.discountHours = this.getDiscountedHours(item);
            item.approval.extras = false;
            item.approval.extrasHours = 0;
            item.approval.extrasValue = 0;
            if(this.approvalType == 1){
                item.approval.approvedHours = this.descontar?(item.approval.consultant.contract.mensalHours.valueOf()-item.getDiscountedHours()):item.totalProjectHours;
                item.approval = this.approveProjects(item.approval);
            }else if(this.approvalType == 2){
                item.approval.monthCapacity = this.days*8;
                item.approval.approvedHours = this.descontar?(this.days*8-this.getDiscountedHours(item.approval)):item.totalProjectHours;
                item.approval = this.approveProjects(item.approval);
            }
            item.approval.approvedHours = item.totalProjectHours;
            item.approval.projects.map(project => {
                project.approvedHours = project.total_hours;
                project.approvedValue = Math.ceil(project.total_hours * item.approval.consultant.contract.hourValue);
            });
        }else if(item.approval.status == 2) {
            if(this.extras){
                item.totalValue = item.approval.consultant.contract.hourValue*item.totalProjectHours;
                item.approval.discountHours = 0;
                item.approval.discounted = false;
                item.approval.discountValue = 0;
                item.approval.extras = true;
                item.approval.extrasHours = item.totalProjectHours - this.days*8;
                item.approval.extrasValue = item.approval.extrasHours*item.hourValue;
                item.approval.monthCapacity = this.days*8;
            }
    
            if(!this.extras && !this.descontar){
              item.approval.discounted = false;
              item.approval.discountHours = 0;
              item.approval.discountValue = 0;
              item.approval.extras = false;
              item.approval.extrasHours = 0;
              item.approval.extrasValue = 0;
            }
    
            item.approval.approvedHours = item.totalProjectHours;
            this.approveProjects(item.approval);
        }else{
          item.approval.approvedHours = 0;
        }
        
        if(item.kind = 2 || (item.kind == 1 && item.honorarium == 2))
            item.approval.elegibleForDiscount = this.elegibleForDiscount(item);
        this.setValueProjects(item)

        try{
            this.ApprovalService.update(item.approval);
        }catch(err){
            this.errors.push(item.approval.consultant.name);
        }


    }
    validProjectsSelected(project): boolean {
        return project.pjSelect.find(fnd => fnd.selectedItems.length == 0);
    }

    setValueProjects(objAproval) {
        for(var i=0; objAproval.approval.projects.length > i; i++) {
            objAproval.approval.projects[i].projectFinancialId = objAproval.pjSelect[i].selectedItems[0].id;
            objAproval.approval.projects[i].name = objAproval.pjSelect[i].selectedItems[0].itemName;
        }
      }

    localStorageDays(){
    localStorage.setItem('days', this.days);
    }

    checkMatchHours(approval) {
        switch (approval.consultant.contract.kind) {
            case 1:
              return approval.consultant.contract.honorarium == 1 || (approval.consultant.contract.honorarium == 2 && this.extras);
            case 2:
              return this.extras;
            case 4:
              return true;
            default:
              return false;
        }
    }

    getDiscountedHours(approval){
        if((approval.kind >= 2 || (approval.honorarium && approval.honorarium == 2)) && this.approvalType == 1 && this.descontar && approval.mensalHours > approval.totalProjectHours){
          return (approval.mensalHours-approval.totalProjectHours);
        }else if((approval.kind >= 2 || (approval.honorarium&& approval.honorarium == 2)) && this.approvalType == 2 && this.days && this.descontar && (this.days*8)>approval.totalProjectHours){
          return (this.days*8-approval.totalProjectHours);
        }else if(!this.descontar){
          return approval.totalProjectHours;
        }else{
          return 0;
        }
      }

    getDiscount(approval){
        if((approval.kind >= 2 || (approval.honorarium && approval.honorarium == 2)) && this.approvalType == 1 && this.descontar && approval.mensalHours > approval.totalProjectHours){
            return (approval.mensalHours - approval.totalProjectHours)* approval.hourValue;
        }else if((approval.kind>= 2 || (approval.honorarium && approval.honorarium == 2)) && this.approvalType == 2 && this.days && this.descontar && (this.days*8) > approval.totalProjectHours){
            return (this.days*8 - approval.totalProjectHours)*(approval.contractTotalValue/(this.days*8));
        }
    }

    approveProjects(approval){
        approval.projects.map(project => {
          project.approvedHours = project.total_hours;
          if(this.descontar && this.approvalType == 2){
            project.approvedValue = project.total_hours * (approval.consultant.contract.totalValue/(this.days*8));
          }
          else if(this.extras){
            project.approvedValue = project.total_hours * approval.consultant.contract.hourValue;
          }else{
            project.approvedValue = (approval.totalValue/approval.realizedHours)*project.total_hours;
          }
        });

        return approval;
    }

    onClickExtras(){
        if(this.extras){
          this.approvals.map(approval =>{
              approval.discountHours = 0;
              approval.discounted = false;
              approval.discountValue = 0;
          });
        }
      }
    
      onClickDiscount(){
        if(this.descontar){
            this.approvals.map(approval => {
                approval.extras = false;
                approval.extrasHours = 0;
                approval.extrasValue = 0;
            });
        }
      }

      elegibleForDiscount(approval){
        let response = new ElegibleForDiscount();
        
        if(approval.totalProjectHours < approval.mensalHours)
          response.byContract = true;
        if(this.days && (approval.totalProjectHours < this.days*8))
          response.byCapacity = true
        
        return response;
    }
    
    checkElegibleForDiscount(approvalType:number, checkType:string){
        if(approvalType == 1)
            this.elegibleContractFlag = false;
        if(approvalType == 2)
            this.elegibleCapacityFlag = false;
        let approvalArray = this.approvalsChildren?this.approvalsChildren.toArray():[];
        approvalArray.forEach( item =>{
            if(item.approval.elegibleForDiscount && item.approval.elegibleForDiscount[checkType] == false && this.descontar && this.approvalType == approvalType){
                if(approvalType == 1)
                    this.elegibleContractFlag = true;
                else if(approvalType == 2)
                    this.elegibleCapacityFlag = true;
            }
        });
    }
    
    checkForExtras(){
        let approvalArray = this.approvalsChildren?this.approvalsChildren.toArray():[];
        this.elegibleExtrasFlag = false;
        approvalArray.forEach(item =>{
            if(this.extras && this.approvalType == 1){
                if(item.totalProjectHours < item.mensalHours)
                    this.elegibleExtrasFlag = true;
            }else if(this.extras && this.days && this.approvalType == 2){
                if(item.totalProjectHours < this.days*8){
                    this.elegibleExtrasFlag = true;
                }
            }
        });
    }

    checkHonorarium(){
        let approvalArray = this.approvalsChildren?this.approvalsChildren.toArray():[];
        this.openHoursFlag = false;
        approvalArray.forEach(item =>{
            if(item.approval.consultant.contract && item.approval.consultant.contract.kind == 1 && item.approval.consultant.contract.honorarium == 1)
                if(this.extras || this.descontar)
                    this.openHoursFlag = true;
        });
    }

    sumChildrenProjects(){
        this.approvalsChildren.forEach(children =>{
            children.sumProjectHours(children.approval);
        });

    }

    removeApproval(id){
        _.remove(this.multiApprovals, (approval) => {
            return approval == id; 
        });
        this.approvalsChildren.filter(item =>  item.approval._id != id)
        this.descontar = false;
        this.extras = false;

    }

    checkFlags(){
        this.checkElegibleForDiscount(1,"byContract")
        this.checkElegibleForDiscount(2,"byCapacity")
        this.checkForExtras()
        this.checkHonorarium()
    }

    checkForExternalReferences(item){
        let response = false;
        if(item.projects){
            item.projects.forEach(element => {
              if(!element.customer.financialId || !element.customer.financialName)
                response = true;
            });
        }
        return response;
      }
}



// WEBPACK FOOTER //
// ./src/app/views/approvals/edit-multi-approvals/edit-multi-approvals.component.ts